import React from "react";
import styled, { css } from "styled-components";
import { Badge } from "components/bootstrap";
import { AccessibleCard, HoverForHelp } from "components/common";
import useLayoutVariant from "components/common/PaginatedEntityTable/hooks/useLayoutVariant";
import { useTableFilterContext } from "components/common/PaginatedEntityTable";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
const Container = styled(AccessibleCard)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
    width: 100%;
  `
);
const Row = styled.div(
  ({ theme, justify = "flex-start" }) => css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacings.xs};
    align-items: center;
    justify-content: ${justify};
  `
);
const PredefinedLayoutItem = ({
  title,
  badgeStyle = void 0,
  badgeMeaning = void 0,
  badgeValue = void 0,
  count = void 0,
  description,
  layoutVariant = void 0
}) => {
  const { activeLayoutVariant, selectLayoutVariant } = useLayoutVariant();
  const { resetFilters } = useTableFilterContext();
  const sendTelemetry = useSendTelemetry("security-events");
  const isActive = activeLayoutVariant === layoutVariant || !activeLayoutVariant && !layoutVariant;
  const onClick = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.SECURITY_EVENTS.LAYOUT_VARIANT_SELECTED, {
      app_action_value: {
        layout_variant: layoutVariant != null ? layoutVariant : "default",
        layout_variant_title: title
      }
    });
    resetFilters();
    return selectLayoutVariant(layoutVariant);
  };
  return /* @__PURE__ */ React.createElement(Container, { isActive, onClick }, /* @__PURE__ */ React.createElement(Row, { justify: "space-between" }, /* @__PURE__ */ React.createElement("h3", null, title), /* @__PURE__ */ React.createElement(HoverForHelp, { title: "Layout details" }, /* @__PURE__ */ React.createElement("p", null, description), Number.isInteger(count) && /* @__PURE__ */ React.createElement("i", null, "Metric values are calculated over the last 30 days."))), /* @__PURE__ */ React.createElement(Row, null, Number.isInteger(count) && /* @__PURE__ */ React.createElement("h2", null, /* @__PURE__ */ React.createElement("b", null, count)), Number.isInteger(badgeValue) && badgeStyle && badgeMeaning && /* @__PURE__ */ React.createElement(Badge, { bsStyle: badgeStyle }, `${badgeValue} ${badgeMeaning}`)));
};
export default PredefinedLayoutItem;
